import { render, staticRenderFns } from "./ReportTotalScoreLight.vue?vue&type=template&id=18cfe062"
import script from "./ReportTotalScoreLight.vue?vue&type=script&lang=js"
export * from "./ReportTotalScoreLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports